import { makeRequest } from 'utils/requestLogger';

export default (discussion_id, hand_raise_type, user_id, turn_id) =>
  makeRequest(
    'put',
    `/api/live_discussions/${discussion_id}/enter_queue/${user_id}`,
    { hand_raise_type, turn_id }
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/queue/enterQueue.js